<template>
    <div>
        <div class="title">Viber Campaign Overview</div>
        <viber-campaign-details v-if="campaign.id" :campaign="campaign" />
    </div>
</template>

<script>
    import viberCampaignService from '@/services/viber-campaign-service'
    import ViberCampaignDetails from '@/components/ViberCampaignDetails.vue'
    export default {
        components: { ViberCampaignDetails },
        data() {
            return {
                campaign: {}
            }
        },
        created() {
            this.fetchViberCampaignById(this.$route.params.campaignId)
        },
        methods: {
            fetchViberCampaignById(id) {
                viberCampaignService.getViberCampaignById(id).then(resp => {
                    this.campaign = resp.data
                })
            }
        }
    }
</script>

<style scoped>

.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}
</style>
